import { useState, useEffect } from 'react';
import queryString from 'query-string';
import ssrService from '@tajawal/web-core-sdk-v2/lib/services/ssr.service';
import { $sessionStorage } from '@tajawal/web-core-sdk-v2/lib/services/session-storage.service';
import { $cookie } from '@tajawal/web-core-sdk-v2/lib/services/cookie.service';
// import { PARTNER_REFERER } from '../constants';
var PARTNER_REFERER = 'partner_referer';
export function usePartnerReferer(query) {
    if (query === void 0) { query = null; }
    var _a = useState(null), partnerReferer = _a[0], setPartnerReferer = _a[1];
    useEffect(function () {
        if (!ssrService().isCSR()) {
            return query[PARTNER_REFERER] ? query[PARTNER_REFERER] : null;
        }
        var params = queryString.parse(window.location.search);
        if (params[PARTNER_REFERER]) {
            $sessionStorage.set(PARTNER_REFERER, params[PARTNER_REFERER]);
            $cookie.set(PARTNER_REFERER, params[PARTNER_REFERER]);
        }
        // @ts-ignore
        setPartnerReferer($sessionStorage.get(PARTNER_REFERER));
    }, []);
    useUpdatePartnerCookie();
    return partnerReferer;
}
export function useUpdatePartnerCookie() {
    var sessionPartner = $sessionStorage.get(PARTNER_REFERER);
    var cookiePartner = $cookie.get(PARTNER_REFERER);
    useEffect(function () {
        // to clear cookie on page load
        if (sessionPartner) {
            $cookie.set(PARTNER_REFERER, sessionPartner);
        }
        else if (!sessionPartner && cookiePartner) {
            $cookie.remove(PARTNER_REFERER);
            window.location.reload();
        }
        // to clear cookie if tab close but not on refresh
        window.addEventListener('beforeunload', function () {
            if (sessionPartner) {
                $cookie.set(PARTNER_REFERER, $sessionStorage.get(PARTNER_REFERER));
            }
            else if (!sessionPartner && cookiePartner) {
                $cookie.remove(PARTNER_REFERER);
            }
        });
    }, []);
}
//# sourceMappingURL=usePartnerReferer.js.map